$(document).ready(function () {
  $(".navbar-toggler").click(function () {
    $(".collapse").slideToggle();
  });

  $(".dropdown-toggle").click(function () {
    $(this).parent().toggleClass("activenav");
  });
  $(".submenu .dropdown-toggle").click(function () {
    $(this).parent().toggleClass("activenavv");
  });


  $('.prdqnt .btnqty').on('click', function () {
    var qty = parseInt($(this).parent('.prdqnt').find('.quantity-input').val());
    if ($(this).hasClass('qtyplus')) {
      qty++;
    } else {
      if (qty > 1) {
        qty--;
      }
    }

    qty = (isNaN(qty)) ? 1 : qty;
    $(this).parent('.prdqnt').find('.quantity-input').attr("value", qty);
  });

  $('.prdqntt .btnqty').on('click', function () {
    var qty = parseInt($(this).parent('.prdqntt').find('.quantity-input').val());
    if ($(this).hasClass('qtyplus')) {
      qty++;
    } else {
      if (qty > 1) {
        qty--;
      }
    }

    qty = (isNaN(qty)) ? 1 : qty;
    $(this).parent('.prdqntt').find('.quantity-input').attr("value", qty);
  });


  $(".showhide").click(function () {
    $(".shohide").toggleClass("activeacc");
  });

  $('.accordion .acc:nth-child(1) .acc-head').addClass('active');
  $('.accordion .acc:nth-child(1) .acc-content').slideDown();
  $('.acc-head').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
  });

  $('.announcement').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    // centerMode:true,
    autoplay: true,
    /*adaptiveHeight: true,*/
  });
  $('.instawrapslide').slick({
    dots: false,
    infinite: true,
    speed: 5000,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    cssEase: 'linear',
    autoplaySpeed: 0

  });


  $('.chomecollectslider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow: $(".slideleftbtn"),
    nextArrow: $(".sliderightbtn"),
    // centerMode:true,
  });

  $('.cehomecollectslider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $(".slideleftbtnn"),
    nextArrow: $(".sliderightbtnn"),
    autoplay: false,
  });


  $('.homecategoryslide').slick({
    dots: false,
    infinite: true,
    speed: 1000,
    arrows: false,
    slidesToShow: 8,
    slidesToScroll: 4,
    swipeToSlide: true,
    autoplay: true,
    draggable: true,
    edgeFriction: 0,
    easing: 'linear',
    // touchMove: true,
    // touchThreshold: 0,
    // centerMode:true,

    autoplay: true,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 6,

        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 5,

        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,

        }
      }

    ]

  });


  $('.carthomecategoryslide').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    // centerMode:true,

    autoplay: true,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3,

        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,

        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,

        }
      }

    ]

  });





  (function pdpGalleryVideoControls() {
    var $main = $('.mainimage');
    var $thumb = $('.thumbimage');
    if (!$main.length) return;

    function pauseProductGalleryMedia() {
      $main.find('video').each(function () {
        this.pause();
      });
      $main.find('iframe.js-youtube').each(function () {
        try {
          this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } catch (e) {}
      });
      $main.find('iframe.js-vimeo').each(function () {
        try {
          this.contentWindow.postMessage('{"method":"pause"}', '*');
        } catch (e) {}
      });
    }

    function syncPdpGalleryVideoHeight() {
      var $ref = $main.find('.prd_image--image img').first();
      var h = $ref.length ? $ref.outerHeight() : 0;
      if (!h) {
        var w = $main.find('.slick-slide.slick-active .prd_image').first().width();
        if (w) h = w;
      }
      if (!h) return;
      $main.find('.prd_image--video .prd-video-stage, .prd_image--external_video .prd-video-stage').css('min-height', h + 'px');
      $main.find('.prd_image--video .prd-deferred-media, .prd_image--external_video .prd-deferred-media').css('min-height', h + 'px');
      $main.find('.prd_image--video .deferred-media__poster img, .prd_image--external_video .deferred-media__poster img').css({
        height: h + 'px',
        'object-fit': 'cover',
      });
      $main.find('.prd_image--video video, .prd_image--external_video video').css({
        height: h + 'px',
        'object-fit': 'cover',
      });
      $main.find('.prd_image--video iframe, .prd_image--external_video iframe').css('height', h + 'px');
    }

    function syncPdpGalleryThumbHeights() {
      if (!$thumb.length) return;
      var $ref = $thumb.find('.prd_image--image img').first();
      var h = $ref.length ? $ref.outerHeight() : 0;
      if (!h) {
        var w = $thumb.find('.slick-slide.slick-active .prd_image').first().width();
        if (w) h = w;
      }
      if (!h) return;
      $thumb.find('.prd_image--video .prd_thumb__poster, .prd_image--external_video .prd_thumb__poster').css({
        height: h + 'px',
        width: '100%',
        'object-fit': 'cover',
      });
    }

    function syncPdpGalleryHeights() {
      syncPdpGalleryVideoHeight();
      syncPdpGalleryThumbHeights();
    }

    function bindVideoOverlay($slide) {
      var $stage = $slide.find('.prd-video-stage');
      if (!$stage.length) return;
      var $overlay = $stage.find('.prd-video-overlay-play');
      var video = $stage.find('video')[0];
      if (video) {
        if (video.dataset.prdOverlayBound) return;
        video.dataset.prdOverlayBound = '1';
        function syncOverlay() {
          if (video.paused || video.ended) {
            $overlay.removeAttr('hidden');
          } else {
            $overlay.attr('hidden', '');
          }
        }
        ['play', 'playing', 'pause', 'ended'].forEach(function (ev) {
          video.addEventListener(ev, syncOverlay);
        });
        $overlay.off('click.prdVideo').on('click.prdVideo', function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.play().catch(function () {});
        });
        syncOverlay();
      }
      var iframe = $stage.find('iframe.js-youtube, iframe.js-vimeo')[0];
      if (iframe && !$overlay.data('prdIframeOverlay')) {
        $overlay.data('prdIframeOverlay', true);
        $overlay.off('click.prdIframe').on('click.prdIframe', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (iframe.classList.contains('js-youtube')) {
            iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else if (iframe.classList.contains('js-vimeo')) {
            iframe.contentWindow.postMessage('{"method":"play"}', '*');
          }
          $overlay.attr('hidden', '');
        });
      }
    }

    function playProductGallerySlide($slide) {
      var $dm = $slide.find('deferred-media');
      if (!$dm.length) return;
      var el = $dm[0];
      if (typeof el.loadContent === 'function') {
        el.loadContent(false);
      }
      setTimeout(function () {
        var $stage = $slide.find('.prd-video-stage');
        var $overlay = $stage.find('.prd-video-overlay-play');
        var v = $slide.find('video')[0];
        if (v) {
          v.play().catch(function () {});
        }
        var yt = $slide.find('iframe.js-youtube')[0];
        if (yt && yt.contentWindow) {
          yt.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
        var vm = $slide.find('iframe.js-vimeo')[0];
        if (vm && vm.contentWindow) {
          vm.contentWindow.postMessage('{"method":"play"}', '*');
        }
        if (yt || vm) {
          $overlay.attr('hidden', '');
        }
        bindVideoOverlay($slide);
        setTimeout(function () {
          bindVideoOverlay($slide);
        }, 500);
        setTimeout(function () {
          bindVideoOverlay($slide);
        }, 1000);
      }, 250);
    }

    function handlePdpGalleryActiveSlide(slick, index) {
      var slideEl = slick.$slides.get(index);
      if (!slideEl) return;
      var $slide = $(slideEl);
      pauseProductGalleryMedia();
      if ($slide.find('deferred-media').length) {
        playProductGallerySlide($slide);
      }
    }

    $main.on('init', function (event, slick) {
      syncPdpGalleryHeights();
      handlePdpGalleryActiveSlide(slick, 0);
    });
    $main.on('afterChange', function (event, slick, currentSlide) {
      handlePdpGalleryActiveSlide(slick, currentSlide);
    });
    $main.on('setPosition', function () {
      syncPdpGalleryHeights();
    });
    $thumb.on('setPosition init', function () {
      syncPdpGalleryHeights();
    });
    $(window).on('load resize', function () {
      syncPdpGalleryHeights();
    });
    $main.find('.prd_image--image img').on('load', function () {
      syncPdpGalleryHeights();
    });
    $thumb.find('.prd_image--image img').on('load', function () {
      syncPdpGalleryHeights();
    });

    $('.mainimage').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      fade: false,
      asNavFor: '.thumbimage',
      adaptiveHeight: true,
    });
    $('.thumbimage').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      asNavFor: '.mainimage',
      dots: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
          },
        },
      ],
    });

    syncPdpGalleryHeights();
  })();


  $('.bannertwoslide').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    // centerMode:true,
    fade: true,
    cssEase: 'ease-in-out',
  });



  $("input[name=sizevariant1]").click(function () {
    var size1 = $(this).val();
    $(this).parent().parent().find("li").removeClass("active");
    $(this).parent().addClass("active");
    var size2 = $(".prodvar2 ul li.active input").val();

    if (typeof size2 == 'undefined') {
      var data = size1;
    } else {
      var data = size1 + " / " + size2;
    }

    console.log(data);

    $(".no-js > option").each(function () {
      if ($(this).text() == data) {
        var v_img = $(this).attr("data-val");
        var id = $(this).val();
        var pr = $(this).attr("data-pr"); console.log(pr);
        var inv = $(this).attr("data-inv");
        $(".newprice span").html(pr);
        /*if(inv > 0){
          $(".addcartbtn").prop("disabled",false); 
          $(".addcartbtn span").text("ADD TO CART");
        } else {
          $(".addcartbtn").prop("disabled",true);
          $(".addcartbtn span").text("Out of Stock");
        }*/
        $(".formval").attr("value", id);
        $(".thumb").each(function () {
          var a = $(this).attr("datav");
          if (a == v_img) {

            var b = $(this).parent().parent().attr("data-slick-index"); console.log(b);
            $('.thumbimage').slick('slickGoTo', b);

          }
        });

      }
    });
  });


  $("input[name=sizevariant2]").click(function () {

    var size1 = $(this).val();
    $(this).parent().parent().find("li").removeClass("active");
    $(this).parent().addClass("active");
    var size2 = $(".prodvar1 ul li.active input").val();

    if (typeof size2 == 'undefined') {
      var data = size1;
    } else {
      var data = size2 + " / " + size1;
    }

    console.log(data);

    $(".no-js > option").each(function () {
      if ($(this).text() == data) {
        var v_img = $(this).attr("data-val");
        var id = $(this).val();
        var pr = $(this).attr("data-pr"); console.log(pr);
        var inv = $(this).attr("data-inv");
        $(".newprice span").html(pr);
        /*if(inv > 0){
          $(".addcartbtn").prop("disabled",false); 
          $(".addcartbtn span").text("ADD TO CART");
        } else {
          $(".addcartbtn").prop("disabled",true);
          $(".addcartbtn span").text("Out of Stock");
        }*/
        $(".formval").attr("value", id);
        $(".thumb").each(function () {
          var a = $(this).attr("datav");
          if (a == v_img) {

            var b = $(this).parent().parent().attr("data-slick-index"); console.log(b);
            $('.thumbimage').slick('slickGoTo', b);

          }
        });

      }
    });
  });


  $(".sl1").change(function () {
    var data = $("option:selected", this).text();
    console.log(data);

    $(".no-js > option").each(function () {
      if ($(this).text() == data) {

        var v_img = $(this).attr("data-val");
        var id = $(this).val();
        var pr = $(this).attr("data-pr");
        var inv = $(this).attr("data-inv");
        $(".prdprice span").html(pr);
        /*if(inv > 0){
          $(".addcartbtn").prop("disabled",false); 
          $(".addcartbtn span").text("ADD TO CART");
        } else {
          $(".addcartbtn").prop("disabled",true);
          $(".addcartbtn span").text("Out of Stock");
        }*/
        $(".formvalue").attr("value", id);
        $(".thumb").each(function () {
          var a = $(this).attr("datav");
          if (a == v_img) {

            var b = $(this).parent().parent().attr("data-slick-index"); console.log(b);
            $('.thumbimage').slick('slickGoTo', b);

          }
        });

      }
    });
  });


  $(".slbot").change(function () {
    var data = $("option:selected", this).text();
    console.log(data);

    $(".no-js > option").each(function () {
      if ($(this).text() == data) {
        var v_img = $(this).attr("data-img");
        var id = $(this).val();
        var pr = $(this).attr("data-pr");
        var inv = $(this).attr("data-inv");
        $(".stickyprdimg img").attr('src', v_img);
        $(".stickprdcontetn .newprice").html(pr);
        /*if(inv > 0){
          $(".addcartbtn").prop("disabled",false); 
          $(".addcartbtn span").text("ADD TO CART");
        } else {
          $(".addcartbtn").prop("disabled",true);
          $(".addcartbtn span").text("Out of Stock");
        }*/
        $(".formvall").attr("value", id);
        /*$( ".thumb" ).each(function() {
      var a = $( this ).attr( "datav" );
      if(a == v_img){
        
        var b = $( this ).parent().parent().attr("data-slick-index"); console.log(b);
        $('.thumbimage').slick('slickGoTo', b);
        
      }
    });*/

      }
    });
  });



  $(".quantity__button").click(function (e) {
    setTimeout(function () {
      $("#cart-icon-bubble .svg-wrapper").html('<img class="iconempty" src="//serendipitycandlefactory.com/cdn/shop/t/39/assets/bagicon.png?v=75000059360179314771738431479" alt="" width="21" height="21">');
    }, 3500);
  });

  $("cart-remove-button").click(function (e) {
    setTimeout(function () {
      $("#cart-icon-bubble .svg-wrapper").html('<img class="iconempty" src="//serendipitycandlefactory.com/cdn/shop/t/39/assets/bagicon.png?v=75000059360179314771738431479" alt="" width="21" height="21">');
    }, 3500);
  });
  $(".addcartbtn").click(function (e) {
    setTimeout(function () {
      $("#cart-icon-bubble .svg-wrapper").html('<img class="iconempty" src="//serendipitycandlefactory.com/cdn/shop/t/39/assets/bagicon.png?v=75000059360179314771738431479" alt="" width="21" height="21">');
    }, 3500);
  });

  setTimeout(function () {
    $(".js-filter").first().removeAttr("open");
  }, 3500);





  // Show the first tab and hide the rest
  $('#tabs-nav li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();
  $('#tabs-nav li').click(function () {
    $('#tabs-nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();

    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  $('#tabs-navv li:nth-child(2)').addClass('active');
  $('.tab2').hide();
  $('.tab2:nth-child(2)').show();
  $('#tabs-navv li').click(function () {
    $('#tabs-navv li').removeClass('active');
    $(this).addClass('active');
    $('.tab2').hide();

    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });


  $('.banner-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    // centerMode:true,
    autoplay: true,
    fade: true,
    cssEase: 'ease-in-out',

  });


  $('.customreviewslider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    // centerMode:true,

    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,

        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,

        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,

        }
      }

    ]

  });



  $(".closemenu1").click(function () {
    $(this).parent().parent().parent().find("#sidemenu").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });
});

function toggleSidebar(ref) {
  document.getElementById("sidemenu").classList.toggle('active');
  $("body").addClass("overflow-hidden");
}


function alertFunc() {
  $('.chomecollectslider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: $(".slideleftbtn"),
    nextArrow: $(".sliderightbtn"),
    autoplay: false,
  });
}

function alertFuncc() {
  $('.carthomecategoryslide').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    // centerMode:true,

    autoplay: true,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3,

        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,

        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,

        }
      }

    ]

  });
}

function alertFunccc() {
  $('.cehomecollectslider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $(".slideleftbtnn"),
    nextArrow: $(".sliderightbtnn"),
    autoplay: false,
  });
}



function myFunction() {
  timeout = setTimeout(alertFunc, 3000);
  timeoutt = setTimeout(alertFuncc, 3000);
  timeouttt = setTimeout(alertFunccc, 3000);
}

function addprod(e) {

  var itemsArray = [];
  var customItem = { id: e, quantity: 1 };
  itemsArray.push(customItem);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: { items: itemsArray },
    success: function (data) {
      $.ajax({

        'url': window.location.href,
        'dataType': 'html',
        'method': 'GET',
        'success': function (data) {
          $(".drawer").removeClass("is-empty");
          let form_markupp = $(data).find('#cart-icon-bubble').html();
          $("#cart-icon-bubble").html(form_markupp);
          let form_markup = $(data).find('.drawer__inner').html();
          $(".drawer__inner").html(form_markup);
          setTimeout(alertFunccc, 2000)
        }
      });

    },
    error: function (data) {
      alert(data.responseJSON.description);
    }
  });
}


$(document).ready(function () {
  $(function () {
    var t = $(".hidebtn");
    var stickyProductBarPresent = document.querySelector(".stickyproduct") !== null;
    var STICKY_BAR_BODY_CLASS = "sticky-product-bar-active";

    function syncStickyProductBar() {
      var active = $(window).scrollTop() >= 1000;
      if (active) {
        t.removeClass("hidebtn").addClass("dm-flex");
      } else {
        t.removeClass("dm-flex").addClass("hidebtn");
      }
      if (stickyProductBarPresent) {
        document.body.classList.toggle(STICKY_BAR_BODY_CLASS, active);
      }
    }

    $(window).on("scroll", syncStickyProductBar);
    syncStickyProductBar();
  });
})






